<template>
  <div>
    <vs-popup :title="$t('CreateSerial')" :active.sync="showModal">
      <vs-tabs vs-alignment="fixed" alignment="fixed">
        <vs-tab :label="$t('CreateSerial')" class="mt-2">
          <form>
            <div class="vx-row mb-6">
              <div class="vx-col lg:w-4/5 w-full mb-2">
                <vs-input
                  class="inputx mb-4 mt-1"
                  v-model="info.serial"
                  name="serialName"
                  :label="$t('SerialNumber')"
                  v-validate="'required'"
                  :disabled="
                    !selectedTransactionSerialsCountLessThanEnteredCount
                  "
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('serialName')"
                  >{{ errors.first("serialName") }}</span
                >
              </div>
              <div class="vx-col lg:w-1/5 w-full mt-6">
                <vs-button
                  size="small"
                  radius
                  color="success"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-plus"
                  @click.prevent="addSerial()"
                  class="my-2 lfloat"
                  :disabled="
                    !selectedTransactionSerialsCountLessThanEnteredCount
                  "
                ></vs-button>
              </div>
            </div>
          </form>

          <vs-table :data="selectedTransactionSerials" class="custom-tbl">
            <template slot="thead">
              <th>#</th>
              <th>{{ $t("SerialNumber") }}</th>
              <th>{{ $t("Action") }}</th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="i" v-for="(serial, i) in data">
                <vs-td>
                  {{ i + 1 }}
                </vs-td>
                <vs-td>
                  {{ serial.serial }}
                </vs-td>
                <vs-td>
                  <vs-button
                    radius
                    color="danger"
                    size="small"
                    type="gradient"
                    icon-pack="feather"
                    icon="icon-x"
                    @click.prevent="deleteSerial(i)"
                    class="d-inline"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <vs-button
            type="filled"
            class="float-right mb-4 mt-4"
            @click.prevent="submitSerialForm"
            >{{ $t("Save") }}</vs-button
          >
        </vs-tab>
        <vs-tab :label="$t('AvailableSerials')" class="mt-2">
          <serials :serialService="serialService" v-if="show"></serials>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.vs-con-input input {
  text-align: right;
}

.custom-tbl td {
  padding: 0.5rem 1rem !important;
}
</style>

<script>
import { mapGetters, mapActions } from "vuex";
import { Validator } from "vee-validate";
import Serials from "./Serials.vue";

const dict = {
  custom: {
    serialName: {
      required: "لطفا شماره سریال را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_TransferTransactions_SerialPopup",
  components: {
    Serials,
  },
  props: {
    show: { default: false },
    serialRowIndex: {
      default: {},
    },
  },
  data() {
    return {
      info: {
        serial: "",
      },
      serialService: "",
    };
  },
  computed: {
    ...mapGetters({
      inventoryTransactions: "transferTransactions/inventoryTransactions",
      selectedTransactionSerials:
        "transferTransactions/selectedTransactionSerials",
      selectedTransactionSerialsCountLessThanEnteredCount:
        "transferTransactions/selectedTransactionSerialsCountLessThanEnteredCount",
      model: "transferTransactions/model",
    }),
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
        this.$validator.reset();
      },
    },
  },
  methods: {
    ...mapActions({
      addSerialToSelectedTransaction:
        "transferTransactions/addSerialToSelectedTransaction",
      removeSerialFromSelectedTransaction:
        "transferTransactions/removeSerialFromSelectedTransaction",
    }),
    addSerial() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addSerialToSelectedTransaction(this.info.serial);
          this.info.serial = "";
          this.$validator.reset();
        }
      });
    },
    deleteSerial(index) {
      this.$swal({
        title: "آیا از حذف این رکورد اطمینان دارید؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "بلی",
        cancelButtonText: "خیر",
      }).then((result) => {
        if (result.value) {
          this.removeSerialFromSelectedTransaction(index),
            this.$swal({
              position: "center-center",
              type: "success",
              text: "رکورد مورد‌نظر با موفقیت حذف شد!",
              showConfirmButton: false,
              timer: 2000,
            });
        }
      });
    },
    submitSerialForm() {
      this.$emit("finish");
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.serialService =
          "/Inventory/api/SerialsOfStockQuery/" +
          this.model.storeId +
          "/" +
          this.model.inventoryTransactionItemCommands[this.serialRowIndex]
            .shelveId +
          "/" +
          this.model.inventoryTransactionItemCommands[this.serialRowIndex]
            .stockId;
      }
    },
  },
};
</script>
